export const CARD_TYPES = {
  DEBIT: { label: "Дебит", color: "blue" },
  CREDIT: { label: "Кредит", color: "gold" },
};

export const CARD_TYPE_OPTIONS = Object.entries(CARD_TYPES).map(([key, v]) => ({
  value: key,
  label: v.label,
}));
export const CARD_TYPE_LABEL = (type) => CARD_TYPES[type]?.label ?? type;
export const CARD_TYPE_COLOR = (type) => CARD_TYPES[type]?.color ?? "default";
